export default "__VITE_ASSET__d59f3bdb__"